// @flow

import fiFI from "./fi_FI.json"
import type { Locale } from "../types/IntlTypes"
import enGB from "./en_GB.json"

const locale: Locale = {
  messages: { ...enGB, ...fiFI },
  name: "fi"
}

export default locale
